import * as React from 'react';
import { colors, space, type } from '@workday/canvas-kit-react/tokens';
import { accessibleHide as accessibleHideCSS, styled } from '@workday/canvas-kit-react/common';
import { FormFieldLabelPosition } from './types';
const labelStyles = [
    {
        ...type.levels.subtext.large,
        fontWeight: type.properties.fontWeights.medium,
        padding: 0,
    },
    ({ labelPosition, accessibleHide }) => {
        if (accessibleHide) {
            return accessibleHideCSS;
        }
        return {
            ...(labelPosition === FormFieldLabelPosition.Left
                ? {
                    marginRight: space.l,
                    minWidth: 180,
                    maxHeight: space.xl,
                    display: 'flex',
                    alignItems: 'center',
                }
                : {
                    display: 'block',
                    marginBottom: space.xxxs,
                }),
        };
    },
];
const RequiredAsterisk = styled('abbr')({
    color: colors.cinnamon500,
    fontSize: '16px',
    fontWeight: 400,
    top: '1px',
    paddingLeft: '2px',
    textDecoration: 'unset',
});
// Used inside the fieldset component instead of a label for accessible radio groups.
const LegendComponent = styled('legend')(...labelStyles, ({ labelPosition }) => {
    if (labelPosition === Label.Position.Top) {
        return {
            width: '100%',
        };
    }
    return {
        float: 'left',
        width: 'auto',
    };
});
const LabelComponent = styled('label')(...labelStyles);
class Label extends React.Component {
    render() {
        const { labelPosition = Label.Position.Top, isLegend = false, required, ...elemProps } = this.props;
        const children = !required ? (this.props.children) : (React.createElement("span", null,
            this.props.children,
            React.createElement(RequiredAsterisk, { key: '0', "aria-hidden": true }, "*")));
        return (React.createElement(React.Fragment, null, isLegend ? (React.createElement(LegendComponent, Object.assign({ labelPosition: labelPosition, isLegend: isLegend }, elemProps, { children: children }))) : (React.createElement(LabelComponent, Object.assign({ labelPosition: labelPosition }, elemProps, { children: children })))));
    }
}
Label.Position = FormFieldLabelPosition;
Label.Position = FormFieldLabelPosition;
export { Label };
